import Component from 'vue-class-component'
import Vue from 'vue'
import ReactButton from './ReactButton.vue'
import commentStore from '../../store/comment/comment-store'

@Component({
  name: 'commentLikeButton',
  props: ['comment'],
  components: { 'react-button' : ReactButton }
})
export default class CommentLikeButton extends Vue {

  protected likeComment (): void {
    commentStore.dispatchLikeComment(this.$props['comment'])
  }

  protected unlikeComment (): void {
    commentStore.dispatchUnlikeComment(this.$props['comment'])
  }

}
